module.exports = __webpack_public_path__ + "img/lafia_castle_card.753088fb.png";